
  const formSelector = '[data-submitted-by="bugreport"]';
  const forms = document.querySelectorAll(formSelector);

  const isForms = () => forms.length;

  if (isForms) {
    forms.forEach((form) => {
      form.addEventListener("submit", (event) => {
        event.preventDefault()
        const project = form.getAttribute('data-project');
        const bug_script_url = form.getAttribute('data-bug-script-url');
        if (!project) return
        if (!bug_script_url) return
        const modal_id = form.getAttribute('data-modal-id');
        sendBugReport(event, parseInt(project), bug_script_url, modal_id)
      })
    })
  }

const closeBugReportModal = (id) => {
    const modalWrapper = document.getElementById(id)
    const modalBox = modalWrapper.querySelector('.base-modal__box')
    const activeClass = '--js-modal-open'
    const closingClass = '--js-modal-closing'

    try {
      const body = document.body
      body.style.padding = null
      body.style.overflow = null
      modalWrapper.classList.add(closingClass)
      modalBox.classList.add(closingClass)

      setTimeout(() => {
        modalWrapper.classList.remove(activeClass, closingClass)
        modalBox.classList.remove(activeClass, closingClass)
      }, 300)

    } catch (error) {
      console.warn('Mondal with id ' + id + ' does not exist.')
    }

  }

const sendBugReport = (event, project: number, bug_script_url = '/bug/', modal_id: string): boolean => {

  const nameEl = document.getElementById('bug-report-name') as HTMLInputElement
  const emailEl = document.getElementById('bug-report-email') as HTMLInputElement
  // const error_description = document.getElementById('bug-report-description').innerHTML
  const errorDescriptionEl = document.getElementById('bug-report-description') as HTMLTextAreaElement
  const errorMessagesEl = document.getElementById('bugreport__error_messages') as HTMLInputElement

  if (!nameEl.value.length) {
    errorMessagesEl.innerHTML = '<span style="color:#fd3e3e">Chyba: Jméno je povinný údaj</span>';
    return false;
  }

  if (!errorDescriptionEl.value.length) {
    errorMessagesEl.innerHTML = '<span style="color:#fd3e3e">Chyba: Popis chyby je povinný údaj</span>';
    return false;
  }


  const issue = {
    username: nameEl.value,
    email: emailEl.value,
    url: window.location.href,
    target_version: '',
    nem_id: 0,
    id_firmy: 0,
    opravny_kod: '',
    id_uzivatele: 0,
    project: project,
    desc: errorDescriptionEl.value
  };

  const issues = []
  issues.push(issue)

  const xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      // Typical action to be performed when the document is ready:
      // document.getElementById("demo").innerHTML = xhttp.responseText;
      console.log(xhttp.responseText);
      nameEl.value = '';
      emailEl.value = '';
      errorDescriptionEl.value = '';
      errorMessagesEl.innerHTML = '<span style="color:#79c431">Úspěšně odesláno. Děkujeme.</span>';
      const bugReportFormEl = document.querySelector('form[name="f-bugreport"]') as HTMLInputElement
      bugReportFormEl.style.display = 'none';

      setTimeout(() => {
        // smazat chyby a obnovit zobrazeni formulare
        bugReportFormEl.style.display = 'flex';
        errorMessagesEl.innerHTML = '';
        closeBugReportModal(modal_id);
      }, 3000);

    }

    if (this.readyState == 4 && this.status !== 200) {
      errorMessagesEl.innerHTML = '<span style="color:#fd3e3e">Chyba API: ' + this.status + '</span>';
    }
  };
  xhttp.open("POST", bug_script_url, true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhttp.send("data=" + encodeURIComponent(window.JSON.stringify(issues)));

  return true;

}
